import { TagInput } from '@cloudflare/kumo'
import { useTranslation } from '../i18n'

interface DomainTagInputProps {
  value: string[]
  onChange: (domains: string[]) => void
  label?: string
  placeholder?: string
}

/** Trim + lowercase, drop empties and duplicates (same rules as the old hand-rolled input). */
export function normalizeDomains(values: string[]): string[] {
  const out: string[] = []
  for (const raw of values) {
    const domain = raw.trim().toLowerCase()
    if (domain && !out.includes(domain)) out.push(domain)
  }
  return out
}

export function DomainTagInput({ value, onChange, label, placeholder }: DomainTagInputProps) {
  const { t } = useTranslation()
  return (
    <TagInput
      label={label}
      aria-label={label ? undefined : t('companies.domains')}
      value={value}
      onValueChange={(next) => onChange(normalizeDomains(next))}
      placeholder={value.length === 0 ? placeholder : undefined}
      autoComplete="off"
      // TagInput only swallows Enter while text is pending; an Enter in the
      // empty field would otherwise submit the whole company form.
      onKeyDown={(e) => {
        if (e.key === 'Enter' && e.currentTarget.value === '') e.preventDefault()
      }}
      labels={{
        input: t('companies.domains'),
        removeValue: (domain) => t('companies.removeDomain', { domain }),
      }}
    />
  )
}
